/*
 * Default Debounce Delay.
 */
export const DEFAULT_DEBOUNCE_DELAY: number = 1000;

/*
 * Small debounce function to delay function calls.
 *
 * @param {Function} callback
 * @param {number} delay
 * @returns {Function}
 */
export default function debounce(callback: Function, delay: number = DEFAULT_DEBOUNCE_DELAY): Function {
	let timeout;

	return function(...args: any[]) {
		// @ts-ignore
		const _this = this;

		const later = () => callback.apply(_this, args);

		clearTimeout(timeout);
		timeout = setTimeout(later, delay);
	};
}
